
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
import DialogAddTopic from './components/DialogAddTopic';
import DialogInfoTopic from './components/DialogInfoTopic';
import DialogEditTopic from './components/DialogEditTopic';
import DialogInfoKeyword from './components/DialogInfoKeyword';
import DialogEditKeyword from './components/DialogEditKeyword';
import DialogDelete from './components/DialogDelete';
import SettingModal from '@/views/BrandAnalysis/components/SettingModal.vue';
  export default {
    components: {
      Notification: Notification,
      SettingModal: SettingModal,
      DialogAddTopic,
      DialogInfoTopic,
      DialogEditTopic,
      DialogInfoKeyword,
      DialogEditKeyword,
      DialogDelete
    },
    data: () => ({
      // keywordcheck: false,
      status_sas: false,
      max_topic: 0,
      max_keyword: 0,
      name_topic_dialog: '',
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",


      buttonAddKeyword: true,
      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,

      search: '',
      dialog: false,
      settingDialog: false,
      dialoginformasitopic: false,
      dialogedittopic: false,
      dialoginformasikeyword: false,
      dialogeditkeyword: false,
      dialogDelete: false,

      
      width_form_keyword: '400px',
      collect_news_val: true,
      collect_twit_val: true,
      collect_ig_val: true,
      collect_fb_val: true,
      collect_tiktok_val: true,
      collect_ytb_val: true,
      
      
      keywordstatus :1,
      keywordstatusedit: [//choice select
              {value_edit: 1, name_edit: "Enabled" },
              {value_edit: 0, name_edit: "Disabled" }
      ],

      status_topic_insert: [//choice select
              {value_topic: 1, name_topic: "Enabled" },
              {value_topic: 0, name_topic: "Disabled" }
      ],
      keywordstatusselect: [//choice select
              {value: 1, name: "Enabled" },
              {value: 0, name: "Disabled" }
      ],
      rolestatus: ['Enabled', 'Disabled'],
      keyword: ['Banjir', 'Tanah Longsor', 'Politik'],
      headers: [
        { text: 'Topic Name', value: 'GROUP_ANALYSIS' },
        { text: '', value: 'infotopic', sortable: false },
        { text: 'Status', value: 'GROUP_STATUS_TEXT'  },
        { text: '', value: 'editstatus', sortable: false , width: '120px'  },
        { text: 'Keyword', value: 'KEYWORD' },
        { text: '', value: 'infokeyword', sortable: false, width: '170px' },
      ],
      
      item_insert_dinamis: [
        {keywordname : ''}
      ],
      
      item_edit_keyword_dinamis: [
        {keywordname : '',id_keyword : '',status : '',checknews : '',checktwet : '',checkytb : '',checktiktok : '',checkig : ''}
      ],
      
      id_keyword: [],
      topicitem: [],
      topic: [],
      table: [],
      id_topic: '',
      createnametopic: '',
      createdatetopic: '',
      updatenametopic: '',
      updatedatetopic: '',

      
      createnamekeyword: '',
      createdatekeyword: '',
      updatenamekeyword: '',
      updatedatekeyword: '',
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      showNoData: false,
      noDataMessage: '',


      // Group Analysis properties
      dialogGroupAnalysis: false,
      dialogDeleteGroupAnalysis: false,
      searchGroupAnalysis: '',
      tableLoadingGroupAnalysis: false,
      btnloadgroupanalysis: false,
      dataTableGroupAnalysis: [],
      editedIndexGroupAnalysis: -1,
      editedItemGroupAnalysis: {},
      defaultItemGroupAnalysis: {},
      analysisGroup: '',
      analysisGroupRole: [
        v => !!v || 'Fullname is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      nameBrand: '',
      brandCategory: '',
      accountTwetter: '',
      accountIg: '',
      accountTiktok: '',
      accountYoutube: '',
      accountFb: '',
      fileGroupAnalysis: '',
      previewImageGroupAnalysis: '',
      statusactivegroupanalysis: 1,
      itemsactivategroupanalysis: [
        {valueactive: 1, name_active: "Active" },
        {valueactive: 0, name_active: "Disable" }
      ],
      id_seq_group_analysis: '',
      image_url_group_analysis: '',
      headersGroupAnalysis: [
        { text: 'Group Analysis', value: 'GROUP_ANALYSIS' },
        { text: 'Brand Name', value: 'NAME_BRAND' },
        { text: 'Brand Category', value: 'BRAND_CATEGORY' },
        { text: 'Twetter', value: 'ACCOUNT_TWETTER' },
        { text: 'Instagram', value: 'ACCOUNT_IG' },
        { text: 'Tik Tok', value: 'ACCOUNT_TIKTOK' },
        { text: 'Youtube', value: 'ACCOUNT_YOUTUBE' },
        { text: 'Facebook', value: 'ACCOUNT_FB' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      insertactgroupanalysis: true,
      updateactgroupanalysis: true,
      deleteactgroupanalysis: true,
      viewactgroupanalysis: true,
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add '+this.$store.state.title : 'Update '+this.$store.state.title
      },

      formTitleGroupAnalysis () {
        return this.editedIndexGroupAnalysis === -1 ? 'Add Group Analysis' : 'Update Group Analysis'
      },
      topicOptions() {
        return this.topicitem.map(t => ({
          SEQ_ID: t.SEQ_ID,
          GROUP_NAME: t.GROUP_NAME,
        }))
      },
      analysisGroupOptions() {
        return this.dataTableGroupAnalysis.map(a => ({
          SEQ_ID: a.SEQ_ID,
          GROUP_ANALYSIS: a.GROUP_ANALYSIS,
        }))
      },
    },
    watch: {
      dialogeditkeyword(val){
        
        val || this.closekeywordDialog()
      },
      
      dialoginformasikeyword(val){
        
        val || this.closeInformasikeywordDialog()
      },
      
      dialoginformasitopic(val){
        val || this.closeInformasiTopicDialog()
      },
      dialogedittopic(val){
        val || this.closeTopicDialog()
      },
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      dialogGroupAnalysis (val) {
        val || this.closeGroupAnalysis()
      },
      dialogDeleteGroupAnalysis (val) {
        val || this.closeDeleteGroupAnalysis()
      },
    },
    created () {
      this.initializeGroupAnalysis()
      this.initialize()
    },
    methods: {
      
      
    getColor(status) {
      return status === 'Disabled' ? 'red' : 'green';
    },

    getColorNumber(status) {
      return status == 1 ? 'green' : 'red';
    },

    initialize () {
        this.tableLoading = true;
        axios.get("brand-topic-keyword",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
            let res = decryptionData(response.data.token);
            this.status_sas = res.status_sas;  
            this.max_topic = res.max_topic;  
            this.max_keyword = res.max_keyword;  
            if(this.status_sas == true){
              if(res.data.length >= this.max_topic){
                this.insertact = false
              }
            }

            if (res.status === 201) {
              this.topic = [];  
              this.noDataMessage = res.messages;
              this.showNoData = true;
              this.tableLoading = false;
              return; 
            }
            this.showNoData = false;
            // ➤ Tambahkan nomor urut permanen
            this.topic = res.data.map((item, index) => ({
              ...item,
              NO_URUT: index + 1   // nomor urut tetap
            }));
            setTimeout(() =>{
              this.loading = false
            // end loading 
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
               
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      saveinsert () {
        const selectedGroup = this.analysisGroupOptions.find(g => g.SEQ_ID === this.editedItem.group_analysis_id)
        axios.post("/brand-topic-keyword/insert", 
            {
              group_analysis_id: this.editedItem.group_analysis_id,
              group_analysis: selectedGroup ? selectedGroup.GROUP_ANALYSIS : '',
              status: this.editedItem.topicstatus ?? 1,
              status_sas:this.status_sas
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                // this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
                this.editedItem = {};
                this.item_insert_dinamis = [
                  { keywordname : '' }
                ];
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
      },
      
      close () {
        this.editedItem.seq_id_topic = '';
        this.editedItem.group_analysis_id = '';
        this.editedItem.topicstatus = 1
        this.dialog = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      add() {
        this.originalData = null
        this.item_insert_dinamis.push({ keywordname: '' })
      },
      remove(item, index) {
        if(index > 0){
          this.item_insert_dinamis.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },

      // =========================================== topik action =================================
      informasiItemTopic(item){
          this.loading = true
          this.createnametopic =item.USERNAME; 
          this.createdatetopic =item.SYS_CREATED_DATE; 
          this.updatenametopic =item.USERNAME_UPDATE; 
          this.updatedatetopic =item.SYS_UPDATED_DATE; 
          setTimeout(() =>{
            this.dialoginformasitopic =true;
            this.loading = false
          },1000)
      },
      
      closeInformasiTopicDialog(){
        this.dialoginformasitopic = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      editItemTopic (item){
        console.log(item)
        if (item) {
          this.id_pinned = item.SEQ_ID;
          // this.editedItem.seq_id_topic = item.GROUP_KEYWORD_ID
          this.editedItem.group_analysis_id = item.GROUP_ANALYSIS_ID
          this.editedItem.topicstatus = item.STATUS
        }
        this.dialogedittopic = true
      },
      saveedittopic(){
        const selectedGroup = this.analysisGroupOptions.find(g => g.SEQ_ID === this.editedItem.group_analysis_id)
        axios.put("/brand-topic-keyword/update", 
            {
              seq_id:this.id_pinned,
              group_analysis_id: this.editedItem.group_analysis_id,
              group_analysis: selectedGroup ? selectedGroup.GROUP_ANALYSIS : '',
              status_topic: this.editedItem.topicstatus,
              status_sas:this.status_sas
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                // this.$router.push('/SettingKeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          this.closeTopicDialog();
      },
      closeTopicDialog(){
        this.dialogedittopic = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      // =========================================== end topik action =================================
      // =========================================== Keyword action =================================
      informasiItemKeyword(item){
        // alert(item);
        this.id_pinned = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-keyword-topic",
          data: {
            status_sas : this.status_sas,
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            if(dat.length > 0){
              this.createnamekeyword =dat[0].SYS_CREATED_BY; 
              this.createdatekeyword =dat[0].SYS_CREATED_DATE; 
              this.updatenamekeyword =dat[0].SYS_UPDATED_BY; 
              this.updatedatekeyword =dat[0].SYS_UPDATED_DATE; 
            }
            this.dialoginformasikeyword =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      
      closeInformasikeywordDialog(){
        this.dialoginformasikeyword = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      editItemKeyword (item,group_analysis_id,topic){
        // alert('aaa')
        this.name_topic_dialog = topic
        this.id_pinned = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-keyword-topic",
          data: {
            status_sas : this.status_sas,
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            const collect_news = (response.data.collect_news);
            const collect_twetter = (response.data.collect_twetter);
            const collect_ytb = (response.data.collect_ytb);
            const collect_tiktok = (response.data.collect_tiktok);
            const collect_instagram = (response.data.collect_instagram);
            const cont_colect_active = (response.data.cont_colect_active);
            const collect_fb = (response.data.collect_fb);

            this.collect_news_val = collect_news;
            this.collect_twit_val = collect_twetter;
            this.collect_ig_val = collect_instagram;
            this.collect_tiktok_val = collect_tiktok;
            this.collect_ytb_val = collect_ytb;
            this.collect_fb_val = collect_fb;
            
            if(cont_colect_active == 1){
              this.width_form_keyword = '350px';
            }else  if(cont_colect_active == 2){
              this.width_form_keyword = '450px';
            }else  if(cont_colect_active == 3){
              this.width_form_keyword = '550px';
            }else  if(cont_colect_active == 4){

              this.width_form_keyword = '670px';
            }else  if(cont_colect_active == 5){
              this.width_form_keyword = '790px';

            }else  if(cont_colect_active == 6){
              this.width_form_keyword = '900px';

            }

            if(dat.length > 0){
              //this.keywordstatus =dat[0].KEYWORD_STATUS
              this.keywordstatus =cont_colect_active
            }
            
            let result = '';
            let arr_data = [];
            if(dat.length > 0){
              for (let i = 0; i <  dat.length; i++) { 
                this.add_edit_keyword(); 
                  result = {
                    keywordname : dat[i].KEYWORD,
                    id_topic_keyword : dat[i].GROUP_ID,
                    id_keyword : dat[i].SEQ_ID,
                    status : dat[i].KEYWORD_STATUS,
                    checknews : dat[i].NEWS_FLAG,
                    checktwet : dat[i].TWITTER_FLAG,
                    checkytb : dat[i].YTB_FLAG,
                    checktiktok : dat[i].TIKTOK_FLAG,
                    checkig : dat[i].INSTAGRAM_FLAG,
                    checkfb : dat[i].FB_FLAG
                  };
                  arr_data.push(result);
              }
              this.item_edit_keyword_dinamis= arr_data;
            }else{
                  result = {
                    keywordname : '',
                    id_topic_keyword : '',
                    id_keyword : '',
                    status : '',
                    checknews : '',
                    checktwet : '',
                    checkytb : '',
                    checktiktok : '',
                    checkig : '',
                    checkfb : '',
                  };
                  arr_data.push(result);
                  this.item_edit_keyword_dinamis= arr_data;
            }

            if(this.status_sas == true){
              if(this.item_edit_keyword_dinamis.length >= this.max_keyword){
                this.buttonAddKeyword = false
              }else{
                this.buttonAddKeyword = true

              }
            }
            this.dialogeditkeyword =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      
      add_edit_keyword() {
        this.originalData = null
        this.item_edit_keyword_dinamis.push({ keywordname: '',checktwet:'' })
        if(this.status_sas == true){
          if(this.item_edit_keyword_dinamis.length >= this.max_keyword){
            this.buttonAddKeyword = false
          }
        }
            
      },
      checkedkeywordCollection(item,index,collection) {
        if(collection == 'NEWS'){
          if(item.checknews == undefined || item.checknews == false){
            item.checknews = false
          }
          if ( item.checknews == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checknews: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checknews: false });
          }
        }else if(collection == 'TWITTER'){
          if(item.checktwet == undefined || item.checktwet == false){
            item.checktwet = false
          }
          if ( item.checktwet == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktwet: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktwet: false });
          }

        }else if(collection == 'YOUTUBE'){
          if(item.checkytb == undefined || item.checkytb == false){
            item.checkytb = false
          }
          if ( item.checkytb == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkytb: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkytb: false });
          }
          
        }else if(collection == 'TIKTOK'){
          if(item.checktiktok == undefined || item.checktiktok == false){
            item.checktiktok = false
          }
          if ( item.checktiktok == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktiktok: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktiktok: false });
          }
          
        }else if(collection == 'INSTAGRAM'){
          if(item.checkig == undefined || item.checkig == false){
            item.checkig = false
          }
          if ( item.checkig == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkig: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkig: false });
          }
          
        }else if(collection == 'FACEBOOK'){
          if(item.checkfb == undefined || item.checkfb == false){
            item.checkfb = false
          }
          if ( item.checkfb == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkfb: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkfb: false });
          }
          
        }
        console.log(this.item_edit_keyword_dinamis)

      },
      remove_edit_keyword(item, index) {
        if(index > 0){
          if(item.id_keyword != null){
            axios({
              method: "delete",
              url: "/delete-keyword-topic",
              data: {
                seq_id_keyword: item.id_keyword
              },
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
            })
            .then((response) => {
              // handle success
              this.editItemKeyword(item.id_topic_keyword);
              console.log(response);
              
              this.initialize();
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
          }
          this.item_edit_keyword_dinamis.splice(index, 1)
          if(this.status_sas == true){
            if(this.item_edit_keyword_dinamis.length >= this.max_keyword){
              this.buttonAddKeyword = false
            }else{
              this.buttonAddKeyword = true

            }
          }
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
      saveeditkeyword(){
        axios.put("/update-group-keyword-topic", 
            {
              seq_id_topic:this.id_pinned,
              keyword:this.item_edit_keyword_dinamis,
              status_sas:this.status_sas
              // keywors_status:this.keywordstatus
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                // this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closekeywordDialog()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
      },
      
      closekeywordDialog(){
        this.dialogeditkeyword = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },

      deleteItem (item) {
        this.id_pinned = item.SEQ_ID
        this.id_topic = item.GROUP_KEYWORD_ID
        
        // alert(item);
        console.log(item)
        this.dialogDelete = true
      },
      
      deleteItemConfirm () {
        this.topic.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/brand-topic-keyword/delete",
          data: {
            seq_id: this.id_pinned,
            id_topic: this.id_topic,
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          console.log(error);
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },




















      // ==================== Group Analysis Methods ====================
      initializeGroupAnalysis () {
        // this.tableLoadingGroupAnalysis = true; analisis-group-user
        // analysis_group
        axios.get("analisis-group-user",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            let res = decryptionData(response.data.token);

            this.dataTableGroupAnalysis = res.data;
            setTimeout(() =>{
              this.loading = false
            },1000)
            // this.tableLoadingGroupAnalysis = false;
            // if(localStorage.getItem('authactdeletedt') == 1){ this.deleteactgroupanalysis = true }
            // if(localStorage.getItem('authactinsert') == 1){ this.insertactgroupanalysis = true }
            // if(localStorage.getItem('authactupdate') == 1){ this.updateactgroupanalysis = true }
            // if(localStorage.getItem('authactview') == 1){ this.viewactgroupanalysis = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      // selectfileGroupAnalysis(event) {
      //   this.fileGroupAnalysis = event;
      //   if (event) {
      //     const reader = new FileReader();
      //     reader.onload = (e) => {
      //       this.previewImageGroupAnalysis = e.target.result;
      //     };
      //     reader.readAsDataURL(event);
      //   }
      // },
      // onClearGroupAnalysis() {
      //   this.previewImageGroupAnalysis = '';
      //   this.fileGroupAnalysis = null;
      // },
      // editItemGroupAnalysis(item) {
      //   this.editedIndexGroupAnalysis = this.dataTableGroupAnalysis.indexOf(item)
      //   this.dialogGroupAnalysis = true
      //   this.id_seq_group_analysis = item.SEQ_ID
      //   this.analysisGroup = item.GROUP_ANALYSIS
      //   this.nameBrand = item.NAME_BRAND
      //   this.brandCategory = item.BRAND_CATEGORY
      //   this.accountTwetter = item.ACCOUNT_TWETTER
      //   this.accountIg = item.ACCOUNT_IG
      //   this.accountTiktok = item.ACCOUNT_TIKTOK
      //   this.accountYoutube = item.ACCOUNT_YOUTUBE
      //   this.accountFb = item.ACCOUNT_FB
      //   this.statusactivegroupanalysis = item.STATUS
      //   if (item.PRS_IMAGE) {
      //     this.previewImageGroupAnalysis = item.PRS_IMAGE
      //   } else {
      //     this.previewImageGroupAnalysis = ''
      //   }
      //   this.fileGroupAnalysis = null
      // },
      // async saveGroupAnalysis () {
      //   const isValid = this.$refs.formGroupAnalysis.validate();
      //   const formData = new FormData();
      //   formData.append('image', this.fileGroupAnalysis);
      //   formData.append('seq_id', this.id_seq_group_analysis);
      //   formData.append('analysis_group', this.analysisGroup);
      //   formData.append('name_brand', this.nameBrand);
      //   formData.append('brand_category', this.brandCategory);
      //   formData.append('account_twetter', this.accountTwetter);
      //   formData.append('account_ig', this.accountIg);
      //   formData.append('account_tiktok', this.accountTiktok);
      //   formData.append('account_youtube', this.accountYoutube);
      //   formData.append('account_fb', this.accountFb);
      //   formData.append('status', this.statusactivegroupanalysis);
      //   if (this.editedIndexGroupAnalysis > -1) {
      //       if (isValid) {
      //         this.btnloadgroupanalysis = true
      //         await axios.put("analysis_group/update",formData, 
      //           { headers:
      //             {
      //               'auth-token':localStorage.getItem('token_app'),
      //               'Content-Type': 'multipart/form-data',
      //             }
      //           },
      //           {dataType: 'json'},
      //           )
      //         .then((response) => {
      //               var status = response.data.status
      //               var messages = response.data.msg
      //               if(status == 200){
      //                 this.initializeGroupAnalysis();
      //                 this.alertSuccess = true;
      //                 this.alert_err_attention =  messages;
      //                 this.btnloadgroupanalysis = false
      //                 this.closeGroupAnalysis()
      //               }else{
      //                   this.alertFailed = true;
      //                   this.alert_err_attention =  messages;
      //                   this.btnloadgroupanalysis = false
      //               } 
      //           })
      //         .catch((e) => {
      //               switch (e.response.status) {
      //                   case 404:
      //                         this.$refs.alert.error_login(404);
      //                       break;
      //                   case 403:
      //                         this.$refs.alert.error_login(403);
      //                       break;
      //                   case 400:
      //                         this.alertFailed = true;
      //                         this.alert_err_attention =  e.response.data.msg;
      //                       break;
      //                   default:
      //                       console.log('some other error');
      //                       break;
      //                   }
      //           this.errors=e.response.data.msg;
      //         });
      //       }
      //   } else {
      //     if (isValid) {
      //       this.btnloadgroupanalysis = true
      //       this.dataTableGroupAnalysis.push(this.editedItemGroupAnalysis)
      //       await axios.post("analysis_group/insert",formData, 
      //         { headers:
      //           {
      //             'auth-token':localStorage.getItem('token_app'),
      //             'Content-Type': 'multipart/form-data',
      //           }
      //         },
      //         {dataType: 'json'},
      //         )
      //       .then((response) => {
      //             var status = response.data.status
      //             var messages = response.data.msg
      //             if(status == 200){
      //               this.initializeGroupAnalysis();
      //               this.alertSuccess = true;
      //               this.alert_err_attention =  messages;
      //               this.btnloadgroupanalysis = false
      //               this.closeGroupAnalysis()
      //             }else{
      //                 this.alertFailed = true;
      //                 this.alert_err_attention =  messages;
      //                 this.btnloadgroupanalysis = false
      //             } 
      //         })
      //       .catch((e) => {
      //             switch (e.response.status) {
      //                 case 404:
      //                       this.$refs.alert.error_login(404);
      //                     break;
      //                 case 403:
      //                       this.$refs.alert.error_login(403);
      //                     break;
      //                 case 400:
      //                       this.alertFailed = true;
      //                       this.alert_err_attention =  e.response.data.msg;
      //                     break;
      //                 default:
      //                     console.log('some other error');
      //                     break;
      //                 }
      //         this.errors=e.response.data.msg;
      //       });
      //       this.closeGroupAnalysis()
      //     }
      //   }
      // },
      // closeGroupAnalysis () {
      //   this.fileGroupAnalysis = '';
      //   this.image_url_group_analysis = '';
      //   this.analysisGroup = '';
      //   this.nameBrand = '';
      //   this.brandCategory = '';
      //   this.accountTwetter = '';
      //   this.accountIg = '';
      //   this.accountTiktok = '';
      //   this.accountYoutube = '';
      //   this.accountFb = '';
      //   this.onClearGroupAnalysis()
      //   this.dialogGroupAnalysis = false
      //   this.$nextTick(() => {
      //     this.editedItemGroupAnalysis = Object.assign({}, this.defaultItemGroupAnalysis)
      //     this.editedIndexGroupAnalysis = -1
      //   })
      // },
      // deleteItemGroupAnalysis (item) {
      //   this.id_seq_group_analysis = item
      //   this.dialogDeleteGroupAnalysis = true
      // },
      // deleteItemConfirmGroupAnalysis () {
      //   axios({
      //     method: "delete",
      //     url: "analysis_group/delete",
      //     data: {
      //       seq_id: this.id_seq_group_analysis
      //     },
      //     headers:{'auth-token':localStorage.getItem('token_app')},
      //     dataType: 'json'
      //   })
      //   .then((response) => {
      //     var status = response.data.status
      //     var messages = response.data.msg
      //     if(status == 200){
      //       this.initializeGroupAnalysis();
      //       this.alertSuccess = true;
      //       this.alert_err_attention =  messages;
      //       this.closeDeleteGroupAnalysis()
      //     }else{
      //         this.alertFailed = true;
      //         this.alert_err_attention =  messages;
      //     } 
      //   })
      //   .catch(function (error) {
      //     this.alertFailed = true;
      //     this.alert_err_attention =  'Delete Failed '+error;
      //   })
      //   this.closeDeleteGroupAnalysis()
      // },
      // closeDeleteGroupAnalysis () {
      //   this.dialogDeleteGroupAnalysis = false
      //   this.$nextTick(() => {
      //     this.editedItemGroupAnalysis = Object.assign({}, this.defaultItemGroupAnalysis)
      //     this.editedIndexGroupAnalysis = -1
      //   })
      // },
    },
  }